'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserOffice } from '../../Entities/User/UserOffice';
import { UserOfficeCollection } from '../../Collections/User/UserOfficeCollection';

export class UserOfficeRepository extends CoreRepository {
  public getUserOffices(userId: number, options: object = {}) {
    return this.webAPI.getUserOffices(userId, options).then((response) => {
      const collection = new UserOfficeCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserOffice();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public addUserOffice(userId: number, payload: any[]) {
    return this.webAPI.addUserOffice(userId, payload).then((response) => {
      const item = new UserOffice();
      item.hydrate(response);

      return item;
    });
  }

  public updateUserOffice(userId: number, officeId: number, payload: any[]) {
    return this.webAPI.updateUserOffice(userId, officeId, payload).then((response) => {
      return response;
    });
  }

  public deleteUserOffice(userId: number, officeId: number) {
    return this.webAPI.deleteUserOffice(userId, officeId).then((response) => {
      return response;
    });
  }
}
